import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

class ChangeBackground {
  constructor(el) {
    this.dom = {el: el};
    this.dom.units = document.querySelector('[data-js="background-units"]');
    this.dom.target = document.querySelectorAll('[data-js="background-target"]');

    gsap.registerPlugin(ScrollTrigger);

    this.init();
  }

  init() {

    [...this.dom.target].forEach(el => {
      ScrollTrigger.create({
        trigger: el,
        start: 'top 50%',
        // endTrigger: '#otherID',
        end: 'bottom 50%',
        onToggle: (self) => {
          // console.log('toggled, isActive:', self.isActive)
          if (self.isActive) {
            this.dom.units.dataset.is = 'change';
          } else {
            this.dom.units.removeAttribute('data-is');
          }
        },
        // onUpdate: (self) => {
        //   console.log(
        //     'progress:',
        //     self.progress.toFixed(3),
        //     'direction:',
        //     self.direction,
        //     'velocity',
        //     self.getVelocity()
        //   );
        // }
      });
    })
  }
}

export default ChangeBackground